
import { fromEvent as observableFromEvent, Observable } from 'rxjs';
import { distinctUntilChanged, debounceTime, map } from 'rxjs/operators';
import { EventEmitter, ElementRef, OnInit, Directive, Input, Output } from '@angular/core';
import { NgModel } from '@angular/forms';


@Directive({
    selector: '[appDebounce]',
    providers: [NgModel]
})
export class DebounceDirective implements OnInit {

    @Input() delay = 400;
    @Input() event = 'keyup';
    @Output() func: EventEmitter<any> = new EventEmitter();

    constructor(private elementRef: ElementRef, private model: NgModel) { }
    ngOnInit() {
        const eventStream = observableFromEvent(this.elementRef.nativeElement, this.event).pipe(
            map(() => {
                // console.log(this.elementRef.nativeElement.value);
                return this.elementRef.nativeElement.value;
            }
            ),
            debounceTime(this.delay),
            distinctUntilChanged());
        eventStream.subscribe(input => this.func.emit({ input: this.elementRef.nativeElement, fired: event }));
    }

}
